import React, { FunctionComponent } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Loader } from 'rs-emd-ui-atoms';
import { ProductDetailPage, useProductDetailPageQuery } from '../../generated/graphql';
import { ProductDetailPageComponent } from '../../rs-emd-ui-modules/src/components/product-detail-page';
import { RedirectWithStatus } from '../../rs-emd-ui-modules/src/helpers/redirect-with-status.component';
import { IContextInfo } from '../../rs-emd-ui-modules/src/models/master/context-info.model';
import { basketService } from '../../services/basket-service';
import { partsListService } from '../../services/parts-list-service';
import { pdpService } from '../../services/pdp-service';
import { plpService } from '../../services/plp-service';
import { pricingService } from '../../services/pricing-service';
import { productService } from '../../services/product-service';

type PDPWrapperProps = {
  contextInfo: IContextInfo;
};

export const PDPWrapper: FunctionComponent<PDPWrapperProps> = (props: PDPWrapperProps) => {
  const { '*': splat } = useParams();
  // Split the splat into segments
  const segments = splat ? splat.split('/') : [];
  // Last segment is stockCode
  const stockCode = segments.pop();

  let location = useLocation();

  const { loading, error, data } = useProductDetailPageQuery({
    variables: { stockCode: stockCode ?? '' },
    ssr: true,
  });

  if (loading) {
    return <Loader />;
  } else if (error || !data) {
    return <RedirectWithStatus to={process.env.REACT_APP_ERROR_ENDPOINT} statusCode={500} />;
  } else if (!data.productDetailPage.isSuccess) {
    return <RedirectWithStatus to={`/productpage/ProductNotFound?stockcode=${stockCode}`} statusCode={404} />;
  } else if (!decodeURIComponent(location.pathname).endsWith(data.productDetailPage.pdpUrl)) {
    return <RedirectWithStatus to={{ pathname: data.productDetailPage.pdpUrl, search: location.search } as Location} statusCode={301} />;
  }

  return (
    <ProductDetailPageComponent
      key={stockCode} // needed to reload component with initial state
      data={data.productDetailPage as ProductDetailPage}
      contextInfo={props.contextInfo}
      requestSubject={pdpService.requestSubject}
      responseObservable={pdpService.responseObservable}
      partsListService={partsListService}
      basketService={basketService}
      productService={productService}
      pricingService={pricingService}
      plpService={plpService}
      getStockData={productService.getStockData}
      breadCrumbHasBackBtn={Boolean(
        JSON.parse(new URLSearchParams(location.search).get('backToResults') ?? '0')
      )}></ProductDetailPageComponent>
  );
};

export default PDPWrapper;
